<template>
  <button
    @click="openShare"
    class="share-button"
    role="button"
    aria-label="Share"
  >
    <ShareAnimation />
  </button>
</template>

<script>
import ShareAnimation from "@/components/animations/ShareAnimation.vue";

export default {
  components: { ShareAnimation },
  methods: {
    openShare() {
      this.$emit("open-share");
      document.getElementsByTagName("body")[0].classList.add("no-scroll");
    },
  },
};
</script>
